import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { TutorialLibraryBody } from "../TutorialLibrary";
import { Player } from "../TutorialVideo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PcTutorials = () => {
  const [items, setItems] = useState(null);
  const [preview, setPreview] = useState(null);
  const load = useCallback(() => axios.get(`${API}/tutorials`).then((r) => setItems(r.data.items || {})).catch(() => setItems({})), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="rounded-2xl bg-white p-4 sm:p-6" data-testid="pc-tutorials">
      <p className="mb-3 text-sm text-slate-500">ضع رابط يوتيوب لكل صفحة — يظهر للمستخدمين زر «فيديو تعليمي» في تلك الصفحة.</p>
      {items === null ? <p className="text-sm text-slate-400">جارٍ التحميل…</p> : <TutorialLibraryBody items={items} onSaved={load} onPreview={setPreview} />}
      {preview && <Player v={preview} onClose={() => setPreview(null)} />}
    </div>
  );
};
